import { makeStyles } from "tss-react/mui";

export const useStyle = makeStyles()((theme) => ({
    accordion: {
        boxShadow: theme.shadows[2],
        borderRadius: theme.shape.borderRadius,
        "&:before": {
            display: "none",
        },
        "&.Mui-expanded": {
            margin: 0,
        },
    },
    uanInputContainer: {
        padding: theme.spacing(2),
        backgroundColor: theme.palette.background.main,
        borderRadius: theme.shape.borderRadius,
        border: `1px solid ${theme.palette.background.dark}`,
    },
    helperText: {
        color: theme.palette.primary.main,
        marginTop: theme.spacing(-1),
        marginBottom: theme.spacing(1),
    },
    helpText: {
        color: theme.palette.secondary.main,
        marginTop: theme.spacing(1),
    },
    helpLink: {
        color: theme.palette.primary.main,
        textDecoration: "underline",
    },
    instructionBold: {
        fontWeight: theme.typography.fontWeightRegular,
        color: theme.palette.primary.main,
        marginBottom: theme.spacing(1),
        paddingTop: theme.spacing(2),
    },
    checkboxContainer: {
        [theme.breakpoints.down("md")]: {
            marginTop: theme.spacing(5),
        },
    },
    accordionSummary: {
        display: "none",
    },
    accordionDetails: {
        backgroundColor: theme.palette.background.paper,
        padding: theme.spacing(3, 4),
        flexDirection: "column",
    },
    uanNumber: {
        color: theme.palette.text.primary,
    },
    uanBold: {
        fontWeight: theme.typography.fontWeightBold,
    },
    iconButton: {
        color: theme.palette.text.primary,
        padding: theme.spacing(0.5),
        "&:hover": {
            backgroundColor: theme.palette.action.hover,
        },
    },
    validationError: {
        color: theme.palette.error.main,
        marginTop: theme.spacing(2),
        fontWeight: theme.typography.fontWeightBold,
    },
}));
